import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertController, LoadingController, MenuController } from '@ionic/angular';
import { ChatService } from 'src/app/services/chat.service';
import { UserService } from 'src/app/services/user.service';
import { Camera, CameraResultType } from '@capacitor/camera';
import { StorageService } from 'src/app/services/storage.service';
import { environment } from 'src/environments/environment';
import { SocketService } from 'src/app/services/socket.service';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.page.html',
  styleUrls: ['./messages.page.scss'],
})
export class MessagesPage implements OnInit, OnDestroy {

  chatList: any[];
  chatListFiltered: any[];
  chatListLength: number;
  
  userList: any[];
  userListFiltered: any[];
  userListLength: number;

  usersWithChat: number[] = [];
  
  searchText: string = '';

  selectedCategory: number = 0;
  selectedType: string = 'all';
  userCategories: any[] = [];
  loadChat: number;

  selectedUser: any;
  selectedChat: any;

  user: any;
  botUser: any;

  loading: any = null;

  showChatAfterCreation: number = null;

  //GROUPS
  groupEdit: any = null;
  groupEditBackup: any = null;
  groupPictUpdated: boolean = false;

  firstLoad:boolean = true;

  pushAudio: HTMLAudioElement;

  socketEventListeners: any = {};

  constructor(
    private userService: UserService, 
    private chatService: ChatService, 
    private socketService: SocketService,
    private storageSvc: StorageService,
    private alertCtrl: AlertController,
    private menuCtrl: MenuController,
    private loadingCtrl: LoadingController,
    private changeDetection: ChangeDetectorRef,
    private route: ActivatedRoute,
    private router: Router) { }

  ngOnInit() {

    console.log('NG ON INIT MESSAGES PAGE');

    this.pushAudio = new Audio('/assets/push.mp3');
    this.pushAudio.load();

    this.menuCtrl.enable(true);

    //this.chatService.logAllChats();

    this.initializeMessages();

    this.route.queryParams.subscribe((e) => {
      console.log('queryParams',e);
      if(e && e.chatId) {
        this.loadChat = parseInt(e.chatId);

        if (this.chatListFiltered && this.chatListFiltered.length > 0) {
          this.selectChat(this.chatListFiltered.find(c => c.id === this.loadChat));
          this.loadChat = null;

          //console.log('SLC1', this.chatList, this.chatListFiltered, this.selectedChat);
          this.cancelGroupEdition();
        }
      }
    });  
  }

  ngOnDestroy(): void {
    for (const [evt, listener] of Object.entries(this.socketEventListeners)) {
      this.socketService.unsubscribe(evt, listener);
    }
  }

  initializeMessages() {

    if (this.userService.currentUser && this.userService.currentUser.id && this.userService.userCategories.length > 0) {

      this.chatList = [];
      this.userCategories = this.userService.userCategories;
      this.botUser = this.userService.botUser;
      this.userService.currentUser$.subscribe(next => {
        console.log('USER CHANGES ON MESSAGES PAGE');
        this.user = next;

        if (this.user && this.user.id && this.firstLoad) {
          this.firstLoad = false;
          this.refreshChatList();
          this.initSocketSubscriptions();
        }
      });
    }
    else{
      setTimeout(()=>this.initializeMessages(),1000);
    }
  }

  refreshChatList() {
    this.chatService.getUserChats().subscribe(res => {
      if (!res.error) {

        this.userList = res.users;

        res.chats.forEach(c => {
          this.parseChatToList(c);
        });

        this.updateFilteredChatList();
        this.updateFilteredUserList();

        console.log('filtered lists', this.chatListFiltered, this.userListFiltered);

        if (res.createdChatId) {
          this.loadChat = res.createdChatId;
        }

        if (this.loadChat) {
          this.selectChat(this.chatListFiltered.find(c => c.id === this.loadChat));
          this.loadChat = null;
        }
      }
    });
  }

  parseChatToList(chat) {
    chat.contact = {};
    chat.contacts = {};
    chat.contactNames = '';

    chat.users.forEach(u => {
      if (u.user_id !== this.user.id) {
        if (!chat.is_group) {
          if (u.enabled) {
            if (!this.usersWithChat.includes(u.user_id)) {
              this.usersWithChat.push(u.user_id);
            }

            chat.contact = this.userList.find(user => user.id === u.user_id);

            if (!chat.contact) {
              console.log(`Contact not found - chatId: ${chat.id} - userId: ${u.user_id}`);
            }
          }
        }
        else {
          let iu = this.userList.find(user=> user.id === u.user_id);

          if (!iu) {
            console.log(`Group contact not found - chatId: ${chat.id} - userId: ${u.user_id}`);
          }
          else {
            chat.contacts[u.user_id] = iu;

            if (u.enabled) {
              chat.contactNames += (chat.contactNames != '' ? ', ' : '') + iu.username;
            }
          }
        }
      }
    });

    let idx = this.chatList.findIndex(c => c.id == chat.id);

    if (idx < 0) {
      this.chatList.push(chat);
    }
    else {

      /*if (this.chatList[idx].unread < chat.unread) {
        this.showIncomingMessage(chat);
      }*/

      this.chatList[idx] = chat;
    }
  }

  updateFilteredChatList() {

    let searchText = this.searchText.toLowerCase();
    this.chatListFiltered = this.chatList.filter(chat => {
      let txt = (chat.is_group ? chat.group_name : ( chat.contact ? chat.contact.username + '_' + chat.contact.email + '_' + chat.contact.company_name : ''));
      return ((searchText == '' || txt.toLowerCase().indexOf(searchText) >= 0) && (!this.selectedType || this.selectedType == 'all' || 
      (this.selectedType == 'members' && (chat.is_group || chat.contact?.is_member)) ||
      (this.selectedType == 'customers' && !chat.is_group && chat.contact?.is_customer)));
    });

    this.chatListFiltered.sort((a, b) => {

      const d1 = a.last_message?.created_at || '0000';
      const d2 = b.last_message?.created_at || '0000';

      return (d1 > d2 ? -1 : 1);
    })
  }

  updateFilteredUserList() {

    let searchText = this.searchText.toLowerCase();
    this.userListFiltered = this.userList.filter(usr => {
      return (((searchText == '' || (usr.username+'_'+usr.email+'_'+usr.company_name).toLowerCase().indexOf(searchText) >= 0)
        && this.user.id != usr.id) && (!this.selectedType || this.selectedType == 'all' || (this.selectedType == 'members' && usr.is_member) ||
        (this.selectedType == 'customers' && usr.is_customer)));
    });
  }

  initSocketSubscriptions() {

    //Set socket event listener for user created
    this.socketEventListeners[`userCreated`] = (data) => {
      console.log('SOCKET MESSAGES -> userCreated', data);
      this.updateListUser(data.userId);
    }

    //Set socket event for user updated
    this.socketEventListeners[`userUpdated`] = (data) => {
      console.log('SOCKET MESSAGES -> userUpdated', data);
      this.updateListUser(data.userId);
    }

    this.socketEventListeners[`userChatCreated:${this.user.id}`] = (data) => {
      console.log('SOCKET MESSAGES -> userChatCreated', data);
      this.updateListChat(data.chatId);
    }

    this.socketEventListeners[`userChatUpdated:${this.user.id}`] = (data) => {
      console.log('SOCKET MESSAGES -> userChatUpdated', data);
      this.updateListChat(data.chatId);
    }

    /*  userChatCreated:forAgentID {chatId}  --- WHEN user is customer and has no chats
    *  userChatCreated:forContact {chatId}  --- WHEN user creates a new direct chat
    *  userChatUpdated:${cu.user_id}`, {chatId: chatId})  -- ON /chat/updateChat
    *  userChatCreated:forContacts {chatId}  --- ON /updateGroup IF NEW GROUP
    *  userChatUpdated:forContacts {chatId}  --- ON /updateGroup IF EXISTING GROUP
    *  userChatUpdated:forContacts {chatId}  --- ON /createMessage
    *  userNewMessage:forContacts {chatId}  --- ON /createMessage
    *  userChatUpdated:forContacts {chatId}  --- ON /deleteMessages*/
    
    for (const [evt, listener] of Object.entries(this.socketEventListeners)) {
      this.socketService.subscribe(evt, listener);
    }
  }

  updateListUser(userId) {

    this.userService.getUser(userId).subscribe(res => {
      if (!res.error && res.user) {
        let idx = this.userList.findIndex(u => u.id === res.user.id)

        if (idx >= 0) {
          this.userList[idx] = res.user;
        }
        else {
          this.userList.push(res.user);
        }
        
        this.updateFilteredUserList();     

        //find user realted chats
        const userRelatedChats = this.chatList.filter(c => {
          return (c.users.findIndex(u => u.user_id == res.user.id) >= 0);
        })

        let reselectChatId = null;
        if (userRelatedChats.length > 0) {
          userRelatedChats.forEach((c) => {
            this.parseChatToList(c);
            if (this.selectedChat?.id == c.id) {
              reselectChatId = c.id;
            }            
          })
          this.updateFilteredChatList()

          if (reselectChatId) {
            this.selectChat(this.chatListFiltered.find(c => c.id === reselectChatId))
          }          
        }
        
        this.changeDetection.detectChanges();
      }
    })    
  }

  updateListChat(chatId) {

    this.chatService.getChat(chatId).subscribe(res => {
      if (!res.error && res.chat) {

        this.parseChatToList(res.chat);
        
        this.updateFilteredChatList();
        this.updateFilteredUserList();

        if (this.showChatAfterCreation && this.showChatAfterCreation > 0) {
          this.router.navigate(['/messages'], {queryParams: {chatId: this.showChatAfterCreation}});
          this.showChatAfterCreation = null;
        }
        else if (this.selectedChat?.id == res.chat.id) {
          this.selectChat(this.chatListFiltered.find(c => c.id === res.chat.id))
        }   
        
        this.changeDetection.detectChanges();
      }
    })    
  }

  approveChat(e, chat) {
    e.preventDefault();
    e.stopPropagation();

    this.alertCtrl.create({
      header: 'Aprobar contacto',
      message: 'Mensaje de bienvenida',
      inputs: [{
        name: 'apmsg',
        type: 'textarea',
        placeholder: 'Mensaje de bienvenida',
        value: 'Bienvenid@ a AsistenteCompras.com, cómo puedo ayudarte?',
        attributes: {
          rows: 4,
        }
      }],
      buttons: [{
        text: 'CANCELAR',
        role: 'cancel',
        cssClass: 'secondary',
      },{
        text: 'APROBAR',
        handler: (values) => {
          this.chatService.approveChat(chat.id).subscribe((res)=>{
            if (!res.error) {
              this.chatService.createMessage(chat.id, 'text', values.apmsg).subscribe((resA)=>{
                console.log('Created MSG for approval', resA);
              });
            }
          });
        }
      }]
    }).then(alert => {
      alert.present();
    });
  }

  selectCategory(ev) {
    this.selectedCategory = ev.target.value;
    //this.updateFilteredList();
  }

  searchUsers(ev) {
    console.log('search', ev.target.value);
    this.searchText = ev.target.value.toLowerCase();
    this.updateFilteredUserList();
    this.updateFilteredChatList();
  }

  filterByType(ev) {
    this.selectedType = ev.target.value;
    this.updateFilteredUserList();
    this.updateFilteredChatList();
  }

  selectUser(usr) {
    this.selectedUser = Object.assign({}, usr);
  }

  selectChat(chat) {
    //this.selectedChat = Object.assign({}, chat);
    this.selectedChat = JSON.parse(JSON.stringify(chat));
    this.changeDetection.detectChanges();
  }

  async createDirectChat(contact) {
    this.loading = await this.loadingCtrl.create({
       mode: 'ios',
      message: 'Iniciando conversaci&oacute;n...'
    });
    await this.loading.present();

    this.chatService.createChat(contact.id, true).subscribe((res)=>{
      this.loading.dismiss();
      if (!res.error) {
        console.log('directChatCreado', res.chatId);
        this.showChatAfterCreation = res.chatId;
      }
    });
  }

  /*********** GROUPS *************/
  editGroup(groupChat?) {

    //this.chatService.migrateOldChats();
    if (groupChat) {
      this.groupEdit = {
        id: groupChat.id,
        group_pic: groupChat.group_pic,
        group_name: groupChat.group_name,
        users: groupChat.users
      };
    }
    else {
      this.groupEdit = {
        id: null,
        group_pic: null,
        group_name: null,
        users: []
      };
    }
    
    this.groupPictUpdated = false;
    this.groupEditBackup = Object.assign({}, this.groupEdit);
    this.groupEditBackup.usersCopy = [];
    for(let k in this.groupEdit.users) {
      this.groupEditBackup.usersCopy[k] = Object.assign({}, this.groupEdit.users[k]);
    }
    
  }

  cancelGroupEdition() {
    this.groupEdit = null;
    this.groupEditBackup = null;
    this.groupPictUpdated = false;
  }

  isUntouched(form, field){
    return !form.controls[field] || !form.controls[field].touched;
  }

  wasChangedGroup() {
    let result = false;

    for(let k in this.groupEdit) {
      if(k != 'users' && this.groupEdit[k] !== this.groupEditBackup[k]) {
        result = true;
        break;
      }
    }

    for(let k in this.groupEdit.users) {
      if(!this.groupEditBackup.usersCopy[k] || this.groupEdit.users[k].enabled !== this.groupEditBackup.usersCopy[k].enabled) {
        result = true;
        break;
      }
    }

    return result;
  }

  updateGroupUser(userId) {

    let idx = this.groupEdit.users.findIndex(u => u.user_id == userId);

    if (idx >= 0) {
      if (this.groupEdit.users[idx].enabled && !this.groupEdit.id) {
        this.groupEdit.users.splice(idx, 1);
      }
      else {
        this.groupEdit.users[idx].enabled = !this.groupEdit.users[idx].enabled;
      }
    }
    else {
      this.groupEdit.users.push({
        user_id: userId,
        enabled: true,
        unread: 0
      })
    }

    //this.changeDetection.detectChanges();
  }

  confirmGroupUpdate(groupForm){
    let errors = [];

    if (groupForm.invalid) {
      errors.push('Hay campos incompletos o inválidos');
    }
    else if (Object.keys(this.groupEdit.users).length < 3) {
      errors.push('El grupo debe contener al menos 3 integrantes');
    }

    if (errors.length > 0) {
      this.alertCtrl.create({
        header: 'GUARDAR',
        message: errors.join('\n'),
        buttons: [{
          text: 'OK',
          role: 'cancel',
        }]
      }).then(alert => {
        alert.present();
      });

      /*this.toastEl = await this.toastCtrl.create({
        message: this.errors.join('\n'),
        cssClass: 'pane3-toast',
        position: 'bottom',
        color: 'danger',
        duration: 5000
      });
      this.toastEl.present();*/
    }
    else {
      this.alertCtrl.create({
        header: 'GUARDAR',
        message: 'Seguro quieres guardar los cambios?',
        buttons: [{
          text: 'CANCELAR',
          role: 'cancel',
        },{
          text: 'SI, SEGURO',
          handler: ()=>{
            this.updateGroupChat();
          }
        }],
      }).then(alert => {
        alert.present();
      });
    }
      
  }

  async updateGroupChat() {

    const loader = await this.loadingCtrl.create();
    loader.present();

    let updateObject:any = {}

    if (this.groupPictUpdated) {
      const picSnap = await this.storageSvc.uploadProfilePic(this.groupEdit.group_pic);

      const pic = await picSnap.ref.getDownloadURL();
      
      updateObject.group_pic = pic;
    }

    for(let k in this.groupEdit) {
      if(k !== 'group_pic' && this.groupEdit[k] !== this.groupEditBackup[k]) {
        updateObject[k] = this.groupEdit[k];
      }      
    }

    updateObject['users'] = this.groupEdit['users'];
    
    console.log('GroupUpdateData', updateObject);

    this.chatService.updateGroupChat(this.groupEdit.id, updateObject).subscribe((res)=>{
      loader.dismiss();
      if (!res.error) {
        Object.assign(this.groupEditBackup, updateObject);
        this.groupEdit = Object.assign({}, this.groupEditBackup);
        this.groupPictUpdated = false;
      }
    });
  }

  async takePicture(){
    const image = await Camera.getPhoto({
      quality: 100,
      allowEditing: true,
      resultType: CameraResultType.DataUrl,
      width:500,
      height:500
    });
  
    // image.webPath will contain a path that can be set as an image src.
    // You can access the original file using image.path, which can be
    // passed to the Filesystem API to read the raw data of the image,
    // if desired (or pass resultType: CameraResultType.Base64 to getPhoto)
    var imageUrl = image.dataUrl;
  
    // Can be set to the src of an image now
    this.groupEdit.group_pic = imageUrl;

    this.groupPictUpdated = true;
    
  }

  checkMsgAction(data) {
    if (data == 'editGroup') {
      this.editGroup(this.selectedChat);
    }    
  }

  groupUserEnabled(userId) {
    const usr = this.groupEdit.users.find(u => u.user_id == userId);

    if (usr && usr.enabled) {
      return true;
    }
    return false;
  }

  groupUserDisabled(userId) {
    const usr = this.groupEdit.users.find(u => u.user_id == userId);

    if (usr && !usr.enabled) {
      return true;
    }
    return false;
  }

  showIncomingMessage(chat) {

    this.pushAudio.play();

    /*if (window.Notification) {
      console.log('Notification.permission', Notification.permission);

      if(Notification.permission === "granted") {
        this.showNotification(chat);
      }
      else if (Notification.permission !== "denied") {
        Notification.requestPermission(function (status) {
          if (status === "granted") {
            this.showNotification(chat);
          }
        });

      }
    }*/
  }

  showNotification(chat: any) {
    let title = '';
    let sender = null;
    let notif:any = {
      tag: chat.uid,
      body: ''
    }; 

    if (chat.lastMessageFrom && chat.lastMessageFrom != '') {
      sender = this.userList.find(u => u.uid === chat.lastMessageFrom);
    }
    
    if (chat.isGroup) {
      title = chat.groupName;

      notif.body = (sender ? sender.username.split(',')[0].split(' ')[0] + ': ' : '');
      notif.icon = chat.groupPic || (environment.url + '/assets/group-default.png');
    }
    else {
      title = sender.username + ' (' + sender.company_name + ')';
      
      notif.icon = sender.picture || (sender.isAgent 
        ? (environment.url + '/assets/profile-default-agent.png')
        : (environment.url + '/assets/profile-default.png'));
    }

    notif.body += chat.lastMessagePreview;
    
    new Notification(title, {
      body: notif.body,
      tag: chat.uid,
      icon: notif.icon
      //tag: '',
      //icon: '',
      //icon: '',
      //icon: '',
    });
  }
}

